import { useLocalStorage } from "usehooks-ts";

export function usePhoneEntered() {
  const values = useLocalStorage("phone-number-entered", false);
  return values;
}
